import { type FieldError } from 'react-hook-form';

import { type LangFn } from '~/src/polyglot';

export function getPasswordErrorMessage(error: FieldError, lang: LangFn): string {
  if (error.type === 'minLength') {
    return lang({ message: 'INVITE.ERROR.PASSWORD_MIN' });
  }

  return lang({ message: 'INVITE.ERROR.PASSWORD_REQUIRED' });
}

export function getConfirmPasswordErrorMessage(error: FieldError, lang: LangFn): string {
  if (error.type === 'required') {
    return lang({ message: 'INVITE.ERROR.CONFIRM_REQUIRED' });
  }

  if (error.type === 'minLength') {
    return lang({ message: 'INVITE.ERROR.PASSWORD_MIN' });
  }

  return lang({ message: 'INVITE.ERROR.PASSWORDS_MUST_MATCH' });
}
